module.exports = __webpack_public_path__ + "static/media/icon-heart.9111595a.webp";